import { render, staticRenderFns } from "./RequestVoiceOver.vue?vue&type=template&id=3ea09460&"
import script from "./RequestVoiceOver.vue?vue&type=script&lang=js&"
export * from "./RequestVoiceOver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports